import { colorsObject } from "data/colors/colorPalettes";

export const apiVersions = {
  V1: "v1",
  V2: "v2",
  V3: "v3",
};

export const apiPaths = {
  ADMIN_USERS: 'admin.users',
  ADMIN_USERS_UNAPPROVED: 'admin.unapproved.users',
  ADMIN_REPORT: 'admin.report',
  ADMIN_FAST_LOGIN: 'admin.fast-login',
  ADMIN_PERMISSIONS: 'admin.permission',
  ADMIN_DOMAINS: 'admin.domains',
  ADMIN_OFFERS: 'admin.offers',
  ADMIN_OFFERS_SUBSCRIPTIONS: 'admin.offers-subscriptions',
  ADMIN_OFFERS_ACCESS: 'admin.offers.access',
  ADMIN_OFFERS_PAYOUT: 'admin.offers.payout',
  ADMIN_OFFERS_BLACKLIST_USERS: 'admin.offers.blacklist-users',
  ADMIN_OFFERS_USERS_GUARANTEES: 'admin.offers.users-guarantees',
  ADMIN_OFFERS_TRACKING_LINKS: 'admin.offers.tracking-links',
  ADMIN_GUARANTEES_LOGS: 'admin.guarantees-logs',
  ADMIN_NEWS: 'admin.news',
  ADMIN_COUNTRY: 'admin.country',
  ADMIN_LANDINGS: 'admin.landings',
  ADMIN_LOGIN_HISTORY: 'admin.login-history',
  ADMIN_BALANCE: 'admin.balance',
  ADMIN_LOGS: 'admin.logs',
  ADMIN_PRELANDINGS: 'admin.prelandings',
  ADMIN_TOPUPS: 'admin.topups',
  ADMIN_PAYMENTS: 'admin.payments',
  ADMIN_ORDERS: 'admin.orders',
  ADMIN_ORDERS_ERRORS: 'admin.orders.errors',
  ADMIN_POSTBACK_LOGS: 'admin.postback-logs',
  ADMIN_DASHBOARD: 'admin.dashboard',
  ADMIN_CHANGELOG: 'admin.change-log',

  //AFFILIATE PATHS
  AFFILIATE_DASHBOARD: "affiliate.dashboard",
  AFFILIATE_DOMAINS: "affiliate.domains",
  AFFILIATE_OFFERS_SINGLE: "affiliate.offers",
  AFFILIATE_OFFERS_SUBSCRIPTIONS: "affiliate.offers-subscriptions",
  AFFILIATE_OFFERS_ALL: "affiliate.offers",
  AFFILIATE_OFFERS_HOT: "affiliate.offers",
  AFFILIATE_LOGIN_HISTORY: "affiliate.login-history",
  AFFILIATE_PROFILE: "affiliate.profile",
  AFFILIATE_PAYMENTS_REQUEST: "affiliate.payments",
  AFFILIATE_PAYMENTS_SETTINGS: "affiliate.payment-settings",
  AFFILIATE_BALANCE: "affiliate.balance",
  AFFILIATE_REFERRAL: "affiliate.referral",
  AFFILIATE_REPORT: "affiliate.report",
  AFFILIATE_ORDERS: "affiliate.orders",
  AFFILIATE_POSTBACK: "affiliate.postback",
  AFFILIATE_POSTBACK_LOGS: "affiliate.postback-logs",
  AFFILIATE_CHANGELOG: "affiliate.change-log",
  AFFILIATE_NEWS: "affiliate.news",

  //ADVERTISER PATHS
  ADVERTISER_OFFERS: "advertiser.offers",
  ADVERTISER_ORDERS: "advertiser.orders",
  ADVERTISER_TOPUPS: "advertiser.topups",
  ADVERTISER_LANDINGS: "advertiser.landings",
  ADVERTISER_PRELANDINGS: "advertiser.prelandings",
  ADVERTISER_LOGIN_HISTORY: "advertiser.login-history",
  ADVERTISER_PROFILE: "advertiser.profile",
  ADVERTISER_DASHBOARD: "advertiser.dashboard",
  ADVERTISER_CHANGELOG: "advertiser.change-log",

  RESOURCES: "resources",
  NOTIFICATIONS: "change_log_notifications",
};

export const apiActions = {
  LIST: "list",
  GET: "get",
  CREATE: "create",
  UPDATE: "update",
  UPDATE_EMAIL: "update.email",
  DELETE: "delete",
  OVERVIEW: "overview",
  COUNTRY: "country",
  APPROVED: "approved",
  REJECT: "reject",
  SET_MANAGER: "set-manager",
  RESET_MANAGER: "reset-manager",
  TOTAL: "total",
  LOGS: "logs",
  COUNTER: "counter",
  RESEND: "resend",
  CHECK: "check",
  BALANCE: "balance",
  OFFERS: "offers",
  USERS: "users",
  ADVERTISERS: "advertisers",
  COUNTRIES: "countries",
  REQUEST: "request",
  QUEUE_EMAIL: "queue-email",
  FAVORITE: "favorite",
  REQUEST_ACCESS: "request-access",
  TRACKING_URL: "tracking-url",
  ANALYTICS: "analytics",
  REPORT: "report",
  DYNAMICS: "dynamics",
  ORDERS: "orders",
  SEEN: "seen",
  STATS: "stats",
  TIPALTI: "tipalti",
  COUNT: "count",
  HOT: "hot",
  DOWNLOAD: "download",
  APPROVE_PAYMENT: "approve-payment",
  VIEW_PHONE: "view-phone",
  MASS: "mass-payment-request",
};

export const boolean = {
  boolean: {
    label: "Boolean true/false",
    data: {
      default: {
        label: "No",
        value: "false",
        theme: colorsObject().englishRed,
        booleanValue: 0,
      },
      true: {
        label: "Yes",
        value: "true",
        theme: colorsObject().forrestGreenCrayola,
        booleanValue: 1,
      },
      false: {
        label: "No",
        value: "false",
        theme: colorsObject().englishRed,
        booleanValue: 2,
      },
    },
  },
  booleanString: {
    label: 'Boolean "true"/"false"',
    data: {
      default: {
        label: "No",
        value: "false",
        theme: colorsObject().englishRed,
        booleanValue: 0,
      },
      true: {
        label: "Yes",
        value: "true",
        theme: colorsObject().forrestGreenCrayola,
        booleanValue: 1,
      },
      false: {
        label: "No",
        value: "false",
        theme: colorsObject().englishRed,
        booleanValue: 2,
      },
    },
  },
  booleanYesNo: {
    label: 'Boolean "Yes"/"No"',
    data: {
      default: {
        label: "No",
        value: "no",
        theme: colorsObject().englishRed,
        booleanValue: 0,
      },
      yes: {
        label: "Yes",
        value: "yes",
        theme: colorsObject().forrestGreenCrayola,
        booleanValue: 1,
      },
      no: {
        label: "No",
        value: "no",
        theme: colorsObject().englishRed,
        booleanValue: 2,
      },
    },
  },
  booleanNumber: {
    label: "Boolean 1/0",
    data: {
      default: {
        label: "No",
        value: 0,
        theme: colorsObject().englishRed,
        booleanValue: 0,
      },
      1: {
        label: "Yes",
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
        booleanValue: 1,
      },
      0: {
        label: "No",
        value: 0,
        theme: colorsObject().englishRed,
        booleanValue: 2,
      },
    },
  },
};

export const common = {
  ...boolean,
  devices: {
    label: "Devices",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      desktop: {
        label: "Desktop",
        value: "desktop",
        theme: colorsObject().starCommandBlue,
      },
      mobile: {
        label: "Mobile",
        value: "mobile",
        theme: colorsObject().rebeccaPurple,
      },
      tablet: {
        label: "Tablet",
        value: "tablet",
        theme: colorsObject().ochre,
      },
      unknown: {
        label: "Unknown",
        value: "unknown",
        theme: colorsObject().darkByzantium,
      },
    },
  },
  empty: {
    label: "Empty",
    data: {},
  },
};

export const user = {
  usersStatus: {
    label: "Users status",
    data: {
      default: {
        label: "Unknown",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Admin",
        value: 1,
        theme: colorsObject().amazon,
      },
      2: {
        label: "Account Manager",
        value: 2,
        theme: colorsObject().burntSienna,
      },
      3: {
        label: "Advertiser",
        value: 3,
        theme: colorsObject().rebeccaPurple,
      },
      4: {
        label: "Affiliate",
        value: 4,
        theme: colorsObject().starCommandBlue,
      },
      5: {
        label: "Support",
        value: 5,
        theme: colorsObject().amaranth,
      },
      6: {
        label: "Finance",
        value: 6,
        theme: colorsObject().flickrPink,
      },
      99: {
        label: "Banned",
        value: 99,
        theme: colorsObject().englishRed,
      },
    },
  },
  usersType: {
    label: "Users type",
    data: {
      default: {
        label: "Unknown",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Internal",
        value: 1,
        theme: colorsObject().starCommandBlue,
      },
      2: {
        label: "External",
        value: 2,
        theme: colorsObject().royalPurple,
      },
    },
  },
  trafficType: {
    label: "Traffic type",
    data: {
      default: {
        label: "Unknown",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      "facebook": {
        label: "Facebook",
        value: "facebook",
        theme: colorsObject().amazon,
      },
      "google": {
        label: "Google",
        value: "google",
        theme: colorsObject().burntSienna,
      },
      "native": {
        label: "Native",
        value: "native",
        theme: colorsObject().rebeccaPurple
      },
      "push": {
        label: "Push",
        value: "push",
        theme: colorsObject().starCommandBlue
      },
      "other": {
        label: "Other",
        value: "other",
        theme: colorsObject().amaranth
      }
    }
  }
};

export const domains = {
  domainsStatus: {
    label: "Domains status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Active",
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
      },
      2: {
        label: "Inactive",
        value: 2,
        theme: colorsObject().englishRed,
      },
    },
  },
  domainsType: {
    label: "Domains type",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Tracking",
        value: 1,
        theme: colorsObject().fuzzyWuzzy,
      },
    },
  },
  domainsTypeFull: {
    label: "Domains type full",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Tracking",
        value: 1,
        theme: colorsObject().fuzzyWuzzy,
      },
      2: {
        label: "Prelanding",
        value: 2,
        theme: colorsObject().bdazzledBlue,
      },
      3: {
        label: "Landing",
        value: 3,
        theme: colorsObject().blueVioletCrayola,
      },
    },
  },
};

export const offers = {
  offersStatus: {
    label: "Offers status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Active",
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
      },
      2: {
        label: "Test Mode",
        value: 2,
        theme: colorsObject().royalPurple,
      },
      3: {
        label: "Inactive",
        value: 3,
        theme: colorsObject().englishRed,
      },
      4: {
        label: "Suspended",
        value: 4,
        theme: colorsObject().darkByzantium,
      },
    },
  },
  offersType: {
    label: "Offers type",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      "fixed-amount": {
        label: "Fixed amount",
        value: "fixed-amount",
        theme: colorsObject().skobeloff,
      },
      "percentage": {
        label: "Percentage",
        value: "percentage",
        theme: colorsObject().starCommandBlue,
      },
    },
  },
  offersLimitType: {
    label: "Offers limit type",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      "daily": {
        label: "Daily",
        value: "daily",
        theme: colorsObject().skobeloff,
      },
      "hourly": {
        label: "Hourly",
        value: "hourly",
        theme: colorsObject().starCommandBlue,
      },
      "weekly": {
        label: "Weekly",
        value: "weekly",
        theme: colorsObject().eggshell,
      },
      "unlimited": {
        label: "Unlimited",
        value: "unlimited",
        theme: colorsObject().internationalOrangeEngineering,
      },
    },
  },
  subscriptionsStatus: {
    label: "Subscriptions status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Active",
        value: 1,
        theme: colorsObject().bottleGreen,
      },
      2: {
        label: "Suspended",
        value: 2,
        theme: colorsObject().darkByzantium,
      },
      3: {
        label: "Expired",
        value: 3,
        theme: colorsObject().bdazzledBlue,
      },
      9: {
        label: "Deleted",
        value: 9,
        theme: colorsObject().englishRed
      },
    },
  },
  subsDescription: {
    label: "Description",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      subscription: {
        label: "Subscription",
        value: "subscription",
        theme: colorsObject().bdazzledBlue,
      },
      paid_content: {
        label: "Paid content",
        value: "paid_content",
        theme: colorsObject().bottleGreen
      },
    },
  },
  subscriptionsParts: {
    label: "Subscription parts",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Hold",
        value: 1,
        theme: colorsObject().bdazzledBlue,
      },
      2: {
        label: "Paid",
        value: 2,
        theme: colorsObject().bottleGreen,
      },
    },
  },
  offersAccess: {
    label: "Offers access",

    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      regular: {
        label: "Regular",
        value: "regular",
        theme: colorsObject().paolaVeroneseGreen,
      },
      vip: {
        label: "Vip",
        value: "vip",
        theme: colorsObject().ochre,
      },
      test: {
        label: "Test",
        value: "test",
        theme: colorsObject().royalPurple,
      },
      private: {
        label: "Private",
        value: "private",
        theme: colorsObject().starCommandBlue,
      },
    },
  },
  offersPaidStatus: {
    label: "Offers paid status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Save from affiliate",
        value: 1,
        theme: colorsObject().starCommandBlue,
      },
      2: {
        label: "Send to advertiser",
        value: 2,
        theme: colorsObject().rebeccaPurple,
      },
      3: {
        label: "Hold",
        value: 3,
        theme: colorsObject().bdazzledBlue,
      },
      4: {
        label: "Confirmed",
        value: 4,
        theme: colorsObject().bottleGreen,
      },
      5: {
        label: "Cancelled",
        value: 5,
        theme: colorsObject().brickRed,
      },
      6: {
        label: "Trash",
        value: 6,
        theme: colorsObject().rhythm,
      },
      7: {
        label: "Unknown",
        value: 7,
        theme: colorsObject().darkByzantium,
      },
      8: {
        label: "Buyout approved",
        value: 8,
        theme: colorsObject().littleBoyBlue,
      },
      9: {
        label: "Buyout hold",
        value: 9,
        theme: colorsObject().olivine,
      },
      10: {
        label: "Buyout rejected",
        value: 10,
        theme: colorsObject().paradisePink,
      },
    },
  },
  offersPaidStatusLimited: {
    label: "Offers paid status limited",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      3: {
        label: "Hold",
        value: 3,
        theme: colorsObject().bdazzledBlue,
      },
      4: {
        label: "Confirmed",
        value: 4,
        theme: colorsObject().bottleGreen,
      },
    },
  },
  offersDeviceType: {
    label: "Offers device type",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Mobile",
        value: 1,
        theme: colorsObject().ming,
        icon: "mobile",
      },
      2: {
        label: "Desktop",
        value: 2,
        theme: colorsObject().bdazzledBlue,
        icon: "desktop",
      },
    },
  },
  offersCategory: {
    label: "Offers category",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Leadgen",
        value: 1,
        theme: colorsObject().skobeloff,
      },
      "eCommerce": {
        label: "eCommerce",
        value: "eCommerce",
        theme: colorsObject().starCommandBlue,
      },
      3: {
        label: "Mobile Content",
        value: 3,
        theme: colorsObject().jazzberryJam,
      },
      4: {
        label: "App Installs",
        value: 4,
        theme: colorsObject().flickrPink,
      },
    },
  },
  offersVertical1: {
    label: "Offers vertical leadgen (category 1)",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Software",
        value: 1,
        theme: colorsObject().lavenderFloral,
      },
      2: {
        label: "Casino",
        value: 2,
        theme: colorsObject().turquoiseGreen,
      },
      3: {
        label: "Forex",
        value: 3,
        theme: colorsObject().maximumBlueGreen,
      },
      4: {
        label: "Dating",
        value: 4,
        theme: colorsObject().fuzzyWuzzy,
      },
      5: {
        label: "Sweepstakes",
        value: 5,
        theme: colorsObject().fandago,
      },
      6: {
        label: "Finance/Loans",
        value: 6,
        theme: colorsObject().bitterSweet,
      },
      7: {
        label: "Gaming",
        value: 7,
        theme: colorsObject().maximumBluePurple,
      },
      8: {
        label: "Social",
        value: 8,
        theme: colorsObject().orangeYellowCrayola,
      },
      9: {
        label: "Shopping",
        value: 9,
        theme: colorsObject().mauve,
      },
      10: {
        label: "Entertainment",
        value: 10,
        theme: colorsObject().lightBlue,
      },
      11: {
        label: "SmartLink",
        value: 11,
        theme: colorsObject().keyLime,
      },
      12: {
        label: "Crypto",
        value: 12,
        theme: colorsObject().amaranth,
      },
      13: {
        label: "Betting",
        value: 13,
        theme: colorsObject().cherryBlossomPink,
      },
      14: {
        label: "Cams",
        value: 14,
        theme: colorsObject().middleBluePurple,
      },
      15: {
        label: "Lottery",
        value: 15,
        theme: colorsObject().maroonX11,
      },
      16: {
        label: "Binary Options",
        value: 16,
        theme: colorsObject().midnightGreenEagleGreen,
      },
    },
  },
  offersFlow1: {
    label: "Offers flow leadgen (category 1)",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "SOI",
        value: 1,
        theme: colorsObject().spaceCadet,
      },
      2: {
        label: "DOI",
        value: 2,
        theme: colorsObject().brunswickGreen,
      },
      3: {
        label: "IVR",
        value: 3,
        theme: colorsObject().barnRed,
      },
      4: {
        label: "CPS",
        value: 4,
        theme: colorsObject().rebeccaPurple,
      },
      5: {
        label: "Hybrid",
        value: 5,
        theme: colorsObject().darkLiverHorses,
      },
    },
  },
  offersVertical2: {
    label: "Offers vertical eCommerce (category 2)",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Sex Toys",
        value: 1,
        theme: colorsObject().orangeYellowCrayola,
      },
      2: {
        label: "Fungus",
        value: 2,
        theme: colorsObject().mauve,
      },
      3: {
        label: "Correctors",
        value: 3,
        theme: colorsObject().lightBlue,
      },
      4: {
        label: "Cholesterol",
        value: 4,
        theme: colorsObject().keyLime,
      },
      5: {
        label: "Health & Beauty",
        value: 5,
        theme: colorsObject().amaranth,
      },
      6: {
        label: "Hair",
        value: 6,
        theme: colorsObject().cherryBlossomPink,
      },
      7: {
        label: "Immunity",
        value: 7,
        theme: colorsObject().amaranth,
      },
      8: {
        label: "Prostatitis",
        value: 8,
        theme: colorsObject().middleBluePurple,
      },
      9: {
        label: "Eyesight",
        value: 9,
        theme: colorsObject().maroonX11,
      },
      10: {
        label: "Hypertension",
        value: 10,
        theme: colorsObject().midnightGreenEagleGreen,
      },
      11: {
        label: "Breast Enlargement",
        value: 11,
        theme: colorsObject().lavenderFloral,
      },
      12: {
        label: "Bones",
        value: 12,
        theme: colorsObject().turquoiseGreen,
      },
      13: {
        label: "Muscle",
        value: 13,
        theme: colorsObject().maximumBlueGreen,
      },
      14: {
        label: "Diabetes",
        value: 14,
        theme: colorsObject().fuzzyWuzzy,
      },
      15: {
        label: "Skin Immunity",
        value: 15,
        theme: colorsObject().fandago,
      },
      16: {
        label: "Fertility Problems",
        value: 16,
        theme: colorsObject().bitterSweet,
      },
      17: {
        label: "Beauty",
        value: 17,
        theme: colorsObject().maximumBluePurple,
      },
      18: {
        label: "Acne",
        value: 18,
        theme: colorsObject().orangeYellowCrayola,
      },
      19: {
        label: "Joints",
        value: 19,
        theme: colorsObject().mauve,
      },
      20: {
        label: "Health Products",
        value: 20,
        theme: colorsObject().lightBlue,
      },
      21: {
        label: "Potency",
        value: 21,
        theme: colorsObject().keyLime,
      },
      22: {
        label: "Accessories",
        value: 22,
        theme: colorsObject().amaranth,
      },
      23: {
        label: "Kitchen",
        value: 23,
        theme: colorsObject().spaceCadet
      },
      24: {
        label: "Home & Garden",
        value: 24,
        theme: colorsObject().brunswickGreen
      },
      25: {
        label: "Video Games",
        value: 25,
        theme: colorsObject().barnRed
      },
      26: {
        label: "Kids Toys",
        value: 26,
        theme: colorsObject().rebeccaPurple
      },
      27: {
        label: "Hemorrhoids",
        value: 27,
        theme: colorsObject().orangeYellowCrayola,
      },
      28: {
        label: "Weight Loss",
        value: 28,
        theme: colorsObject().mauve,
      },
      29: {
        label: "Varicose",
        value: 29,
        theme: colorsObject().lightBlue,
      },
      30: {
        label: "Parasites",
        value: 30,
        theme: colorsObject().keyLime,
      },
      31: {
        label: "CBD",
        value: 31,
        theme: colorsObject().amaranth,
      },
      32: {
        label: "Cystitis",
        value: 32,
        theme: colorsObject().cherryBlossomPink,
      },
      33: {
        label: "Cellulite",
        value: 33,
        theme: colorsObject().middleBluePurple,
      },
      34: {
        label: "Male Enlargement",
        value: 34,
        theme: colorsObject().maroonX11,
      },
      35: {
        label: "Vision",
        value: 35,
        theme: colorsObject().midnightGreenEagleGreen,
      },
      36: {
        label: "Lungs",
        value: 36,
        theme: colorsObject().lavenderFloral,
      },
      37: {
        label: "Brain boosters",
        value: 37,
        theme: colorsObject().turquoiseGreen,
      },
      38: {
        label: "Teeth",
        value: 38,
        theme: colorsObject().maximumBlueGreen,
      },
      39: {
        label: "Esoteric",
        value: 39,
        theme: colorsObject().fuzzyWuzzy,
      },
      40: {
        label: "Psoriasis",
        value: 40,
        theme: colorsObject().fandago,
      },
      41: {
        label: "Hair removal",
        value: 41,
        theme: colorsObject().bitterSweet,
      },
      42: {
        label: "Snoring",
        value: 42,
        theme: colorsObject().maximumBluePurple,
      },
      43: {
        label: "Liver",
        value: 43,
        theme: colorsObject().orangeYellowCrayola,
      },
      44: {
        label: "Smoking addiction",
        value: 44,
        theme: colorsObject().mauve,
      },
      45: {
        label: "Alcohol addiction",
        value: 45,
        theme: colorsObject().lightBlue,
      },
      46: {
        label: "Gastritis",
        value: 46,
        theme: colorsObject().keyLime,
      },
      47: {
        label: "Female Libido",
        value: 47,
        theme: colorsObject().amaranth,
      },
      48: {
        label: "Kidney",
        value: 48,
        theme: colorsObject().cherryBlossomPink,
      },
      49: {
        lable: "Adult Entertainment",
        value: 49,
        theme: colorsObject().darkByzantium
      },
      50: {
        label: "Hearing",
        value: 50,
        theme: colorsObject().amaranth
      },
      51: {
        label: "Wrinkles",
        value: 51,
        theme: colorsObject().amazon
      },
      52: {
        label: "Anti-Age",
        value: 52,
        theme: colorsObject().midnightEagleGreen
      },
      53: {
        label: "Neuropathy",
        value: 53,
        theme: colorsObject().maximumBlueGreen
      }
    },
  },
  offersFlow2: {
    label: "Offers flow eCommerce (category 2)",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "CPL",
        value: 1,
        theme: colorsObject().eggplant,
      },
      2: {
        label: "COD",
        value: 2,
        theme: colorsObject().englishViolet,
      },
      3: {
        label: "CPS",
        value: 3,
        theme: colorsObject().feldgrau,
      },
      4: {
        label: "Rev share",
        value: 4,
        theme: colorsObject().starCommandBlue
      },
    },
  },
  offersVertical3: {
    label: "Offers vertical Mobile Content (category 3)",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "VOD",
        value: 1,
        theme: colorsObject().cherryBlossomPink,
      },
      2: {
        label: "Gaming",
        value: 2,
        theme: colorsObject().middleBluePurple,
      },
      3: {
        label: "Antivirus / Security",
        value: 3,
        theme: colorsObject().maroonX11,
      },
      4: {
        label: "Generic Download",
        value: 4,
        theme: colorsObject().midnightGreenEagleGreen,
      },
      5: {
        label: "Dating",
        value: 5,
        theme: colorsObject().lavenderFloral,
      },
    },
  },
  offersFlow3: {
    label: "Offers flow Mobile Content (category 3)",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Pin Submit",
        value: 1,
        theme: colorsObject().redwood,
      },
      2: {
        label: "DCB- Other",
        value: 2,
        theme: colorsObject().midnightEagleGreen,
      },
      3: {
        label: "DCB - 1 - Click",
        value: 3,
        theme: colorsObject().amaranth,
      },
    },
  },
  offersVertical4: {
    label: "Offers vertical App Installs (category 4)",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Shopping",
        value: 1,
        theme: colorsObject().turquoiseGreen,
      },
      2: {
        label: "Games",
        value: 2,
        theme: colorsObject().maximumBlueGreen,
      },
      3: {
        label: "Travel",
        value: 3,
        theme: colorsObject().fuzzyWuzzy,
      },
      4: {
        label: "Casino",
        value: 4,
        theme: colorsObject().fandago,
      },
    },
  },
  offersFlow4: {
    label: "Offers flow App Installs (category 4)",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Install & Open",
        value: 1,
        theme: colorsObject().sugarPlum,
      },
      2: {
        label: "Registration",
        value: 2,
        theme: colorsObject().darkPink,
      },
      3: {
        label: "Sale",
        value: 3,
        theme: colorsObject().darkSlateGray,
      },
    },
  },
  offersFavorite: {
    label: "Offers favorite",
    data: {
      default: {
        label: "Not favorite",
        value: null,
        theme: colorsObject().englishRed,
      },
      true: {
        label: "Favorite",
        value: "true",
        theme: colorsObject().forrestGreenCrayola,
      },
      false: {
        label: "Not favorite",
        value: "false",
        theme: colorsObject().englishRed,
      },
    },
  },
};
export const reports = {
  reportsCategory: {
    label: "Offers category",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      "Leadgen": {
        label: "Leadgen",
        value: "Leadgen",
        theme: colorsObject().skobeloff,
      },
      "eCommerce": {
        label: "eCommerce",
        value: "eCommerce",
        theme: colorsObject().starCommandBlue,
      },
      "Mobile Content": {
        label: "Mobile Content",
        value: "Mobile Content",
        theme: colorsObject().jazzberryJam,
      },
      "App Installs": {
        label: "App Installs",
        value: "App Installs",
        theme: colorsObject().flickrPink,
      },
    },
  },
  reportsVertical: {
    label: "Reports vertical",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      "Sex Toys": {
        label: "Sex Toys",
        value: "Sex Toys",
        theme: colorsObject().orangeYellowCrayola,
      },
      "Fungus": {
        label: "Fungus",
        value: "Fungus",
        theme: colorsObject().mauve,
      },
      "Correctors": {
        label: "Correctors",
        value: "Correctors",
        theme: colorsObject().lightBlue,
      },
      "Cholesterol": {
        label: "Cholesterol",
        value: "Cholesterol",
        theme: colorsObject().keyLime,
      },
      "Health & Beauty": {
        label: "Health & Beauty",
        value: "Health & Beauty",
        theme: colorsObject().amaranth,
      },
      "Hair": {
        label: "Hair",
        value: "Hair",
        theme: colorsObject().cherryBlossomPink,
      },
      "Immunity": {
        label: "Immunity",
        value: "Immunity",
        theme: colorsObject().amaranth,
      },
      "Prostatitis": {
        label: "Prostatitis",
        value: "Prostatitis",
        theme: colorsObject().middleBluePurple,
      },
      "Eyesight": {
        label: "Eyesight",
        value: "Eyesight",
        theme: colorsObject().maroonX11,
      },
      "Hypertension": {
        label: "Hypertension",
        value: "Hypertension",
        theme: colorsObject().midnightGreenEagleGreen,
      },
      "Breast Enlargement": {
        label: "Breast Enlargement",
        value: "Breast Enlargement",
        theme: colorsObject().lavenderFloral,
      },
      "Bones": {
        label: "Bones",
        value: "Bones",
        theme: colorsObject().turquoiseGreen,
      },
      "Muscle": {
        label: "Muscle",
        value: "Muscle",
        theme: colorsObject().maximumBlueGreen,
      },
      "Diabetes": {
        label: "Diabetes",
        value: "Diabetes",
        theme: colorsObject().fuzzyWuzzy,
      },
      "Skin Immunity": {
        label: "Skin Immunity",
        value: "Skin Immunity",
        theme: colorsObject().fandago,
      },
      "Fertility Problems": {
        label: "Fertility Problems",
        value: "Fertility Problems",
        theme: colorsObject().bitterSweet,
      },
      "Beauty": {
        label: "Beauty",
        value: "Beauty",
        theme: colorsObject().maximumBluePurple,
      },
      "Acne": {
        label: "Acne",
        value: "Acne",
        theme: colorsObject().orangeYellowCrayola,
      },
      "Joints": {
        label: "Joints",
        value: "Joints",
        theme: colorsObject().mauve,
      },
      "Health Products": {
        label: "Health Products",
        value: "Health Products",
        theme: colorsObject().lightBlue,
      },
      "Potency": {
        label: "Potency",
        value: "Potency",
        theme: colorsObject().keyLime,
      },
      "Accessories": {
        label: "Accessories",
        value: "Accessories",
        theme: colorsObject().amaranth,
      },
      "Kitchen": {
        label: "Kitchen",
        value: "Kitchen",
        theme: colorsObject().spaceCadet
      },
      "Home & Garden": {
        label: "Home & Garden",
        value: "Home & Garden",
        theme: colorsObject().brunswickGreen
      },
      "Video Games": {
        label: "Video Games",
        value: "Video Games",
        theme: colorsObject().barnRed
      },
      "Kids Toys": {
        label: "Kids Toys",
        value: "Kids Toys",
        theme: colorsObject().rebeccaPurple
      },
      "Hemorrhoids": {
        label: "Hemorrhoids",
        value: "Hemorrhoids",
        theme: colorsObject().orangeYellowCrayola,
      },
      "Weight Loss": {
        label: "Weight Loss",
        value: "Weight Loss",
        theme: colorsObject().mauve,
      },
      "Varicose": {
        label: "Varicose",
        value: "Varicose",
        theme: colorsObject().lightBlue,
      },
      "Parasites": {
        label: "Parasites",
        value: "Parasites",
        theme: colorsObject().keyLime,
      },
      "CBD": {
        label: "CBD",
        value: "CBD",
        theme: colorsObject().amaranth,
      },
      32: {
        label: "Cystitis",
        value: 32,
        theme: colorsObject().cherryBlossomPink,
      },
      "Cellulite": {
        label: "Cellulite",
        value: "Cellulite",
        theme: colorsObject().middleBluePurple,
      },
      "Male Enlargement": {
        label: "Male Enlargement",
        value: "Male Enlargement",
        theme: colorsObject().maroonX11,
      },
      "Vision": {
        label: "Vision",
        value: "Vision",
        theme: colorsObject().midnightGreenEagleGreen,
      },
      "Lungs": {
        label: "Lungs",
        value: "Lungs",
        theme: colorsObject().lavenderFloral,
      },
      "Brain boosters": {
        label: "Brain boosters",
        value: "Brain boosters",
        theme: colorsObject().turquoiseGreen,
      },
      "Teeth": {
        label: "Teeth",
        value: "Teeth",
        theme: colorsObject().maximumBlueGreen,
      },
      "Esoteric": {
        label: "Esoteric",
        value: "Esoteric",
        theme: colorsObject().fuzzyWuzzy,
      },
      "Psoriasis": {
        label: "Psoriasis",
        value: "Psoriasis",
        theme: colorsObject().fandago,
      },
      "Hair removal": {
        label: "Hair removal",
        value: "Hair removal",
        theme: colorsObject().bitterSweet,
      },
      "Snoring": {
        label: "Snoring",
        value: "Snoring",
        theme: colorsObject().maximumBluePurple,
      },
      "Liver": {
        label: "Liver",
        value: "Liver",
        theme: colorsObject().orangeYellowCrayola,
      },
      "Smoking addiction": {
        label: "Smoking addiction",
        value: "Smoking addiction",
        theme: colorsObject().mauve,
      },
      "Alcohol addiction": {
        label: "Alcohol addiction",
        value: "Alcohol addiction",
        theme: colorsObject().lightBlue,
      },
      "Gastritis": {
        label: "Gastritis",
        value: "Gastritis",
        theme: colorsObject().keyLime,
      },
      "Female Libido": {
        label: "Female Libido",
        value: "Female Libido",
        theme: colorsObject().amaranth,
      },
      "Kidney": {
        label: "Kidney",
        value: "Kidney",
        theme: colorsObject().cherryBlossomPink,
      },
      "Adult Entertainment": {
        lable: "Adult Entertainment",
        value: "Adult Entertainment",
        theme: colorsObject().darkByzantium
      },
      "Hearing": {
        label: "Hearing",
        value: "Hearing",
        theme: colorsObject().amaranth
      },
      "Wrinkles": {
        label: "Wrinkles",
        value: "Wrinkles",
        theme: colorsObject().amazon
      },
      "Anti-Age": {
        label: "Anti-Age",
        value: "Anti-Age",
        theme: colorsObject().midnightEagleGreen
      },
      "Neuropathy": {
        label: "Neuropathy",
        value: "Neuropathy",
        theme: colorsObject().maximumBlueGreen
      }
    },
  },
}
export const offersAccess = {
  offersAccessStatus: {
    label: "Offers access status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Pending",
        value: 1,
        theme: colorsObject().burntSienna,
      },
      2: {
        label: "Approved",
        value: 2,
        theme: colorsObject().forrestGreenCrayola,
      },
      3: {
        label: "Rejected",
        value: 3,
        theme: colorsObject().englishRed,
      },
    },
  },
};

export const offersPayouts = {
  offersPayoutsTable: {
    label: "Offers payouts table",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      user: {
        label: "User",
        value: "user",
        theme: colorsObject().skobeloff,
      },
      offer: {
        label: "Offer",
        value: "offer",
        theme: colorsObject().starCommandBlue,
      },
    },
  },
};

export const offersUsersGuarantees = {
  usersGUaranteesStatus: {
    label: "Users guarantees status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      active: {
        label: "Active",
        value: "active",
        theme: colorsObject().forrestGreenCrayola,
      },
      inactive: {
        label: "Inactive",
        value: "inactive",
        theme: colorsObject().englishRed,
      },
    },
  },
};
export const offersTrackingLinks = {
  trackingLinksStatus: {
    label: "Tracking links status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Active",
        value: "1",
        theme: colorsObject().forrestGreenCrayola,
      },
      2: {
        label: "Suspended",
        value: "2",
        theme: colorsObject().englishRed,
      },
      3: {
        label: "Unknown",
        value: "3",
        theme: colorsObject().rhythm,
      },
      9: {
        label: "Deleted",
        value: "9",
        theme: colorsObject().englishRed,
      },
    },
  }
}

export const prelandings = {
  prelandingsCategory: {
    label: "Prelandings Category",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Test Category",
        value: 1,
        theme: colorsObject().cerise,
      },
    },
  },
  prelandingsStatus: {
    label: "Prelandings Status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Active",
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
      },
      2: {
        label: "Inactive",
        value: 2,
        theme: colorsObject().englishRed,
      },
    },
  },
};

export const landings = {
  landingStatus: {
    label: "Landing status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Active",
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
      },
      2: {
        label: "Inactive",
        value: 2,
        theme: colorsObject().englishRed,
      },
    },
  },
  landingCategory: {
    label: "Landing category",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Test Category",
        value: 1,
        theme: colorsObject().cerise,
      },
    },
  },
};

export const payments = {
  paymentsMethod: {
    label: "Payments method",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      tipalti: {
        label: "Tipalti",
        value: "tipalti",
        theme: colorsObject().royalPurple,
      },
      "usdt-erc20": {
        label: "USDT ERC20",
        value: "usdt-erc20",
        theme: colorsObject().feldgrau,
      },
      "usdt-trc20": {
        label: "USDT TRC20",
        value: "usdt-trc20",
        theme: colorsObject().starCommandBlue,
      },
      webmoney: {
        label: "Web Money",
        value: "webmoney",
        theme: colorsObject().cerise,
      },
      // "capitalist-internal": {
      //   label: "Capitalist Internal Payment",
      //   value: "capitalist-internal",
      //   theme: colorsObject().skobeloff,
      // },
    },
  },
  paymentsMethodCreate: {
    label: "Payments method",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      "usdt-erc20": {
        label: "USDT ERC20",
        value: "usdt-erc20",
        theme: colorsObject().feldgrau,
      },
      "usdt-trc20": {
        label: "USDT TRC20",
        value: "usdt-trc20",
        theme: colorsObject().starCommandBlue,
      },
      webmoney: {
        label: "Web Money",
        value: "webmoney",
        theme: colorsObject().cerise,
      },
      // "capitalist-internal": {
      //   label: "Capitalist Internal Payment",
      //   value: "capitalist-internal",
      //   theme: colorsObject().skobeloff,
      // },
    },
  },
  paymentsStatus: {
    label: "Payments status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Created",
        value: 1,
        theme: colorsObject().bdazzledBlue,
      },
      2: {
        label: "Approved",
        value: 2,
        theme: colorsObject().bottleGreen,
      },
      3: {
        label: "Rejected",
        value: 3,
        theme: colorsObject().brickRed,
      },
      4: {
        label: "Paid",
        value: 4,
        theme: colorsObject().lightGreenCustom,
      },
      5: {
        label: "Returned",
        value: 5,
        theme: colorsObject().pumpkin,
      },
    },
  },
};

export const paymentSettings = {
  paymentSettingsStatus: {
    label: "Payment settings status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      active: {
        label: "Active",
        value: "active",
        theme: colorsObject().forrestGreenCrayola,
      },
      inactive: {
        label: "Inactive",
        value: "inactive",
        theme: colorsObject().bdazzledBlue,
      },
      suspended: {
        label: "Suspended",
        value: "suspended",
        theme: colorsObject().englishRed,
      },
    },
  },
  paymentSettingsAddStatus: {
    label: "Payment settings add status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      active: {
        label: "Active",
        value: "active",
        theme: colorsObject().forrestGreenCrayola,
      },
      inactive: {
        label: "Inactive",
        value: "inactive",
        theme: colorsObject().bdazzledBlue,
      },
    },
  },
};

export const orders = {
  ordersStatus: {
    label: "Orders status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Save from affiliate",
        value: 1,
        theme: colorsObject().starCommandBlue,
      },
      2: {
        label: "Send to advertiser",
        value: 2,
        theme: colorsObject().rebeccaPurple,
      },
      3: {
        label: "Hold",
        value: 3,
        theme: colorsObject().bdazzledBlue,
      },
      4: {
        label: "Confirmed",
        value: 4,
        theme: colorsObject().bottleGreen,
      },
      5: {
        label: "Cancelled",
        value: 5,
        theme: colorsObject().brickRed,
      },
      6: {
        label: "Trash",
        value: 6,
        theme: colorsObject().rhythm,
      },
      7: {
        label: "Unknown",
        value: 7,
        theme: colorsObject().darkByzantium,
      },
      8: {
        label: "Buyout approved",
        value: 8,
        theme: colorsObject().littleBoyBlue,
      },
      9: {
        label: "Buyout hold",
        value: 9,
        theme: colorsObject().olivine,
      },
      10: {
        label: "Buyout rejected",
        value: 10,
        theme: colorsObject().paradisePink,
      },
      11: {
        label: "Error",
        value: 11,
        theme: colorsObject().englishRed,
      },
    },
  },
  orderStatusLimited: {
    label: "Orders status limited",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Save from affiliate",
        value: 1,
        theme: colorsObject().starCommandBlue,
      },
      2: {
        label: "Send to advertiser",
        value: 2,
        theme: colorsObject().rebeccaPurple,
      },
      3: {
        label: "Hold",
        value: 3,
        theme: colorsObject().bdazzledBlue,
      },
      4: {
        label: "Confirmed",
        value: 4,
        theme: colorsObject().bottleGreen,
      },
      5: {
        label: "Cancelled",
        value: 5,
        theme: colorsObject().brickRed,
      },
      6: {
        label: "Trash",
        value: 6,
        theme: colorsObject().rhythm,
      },
      7: {
        label: "Unknown",
        value: 7,
        theme: colorsObject().darkByzantium,
      },
    },
  },
};
export const guaranteesLogs = {
  guaranteesLogsStatus: {
    label: "Guarantees logs status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      "hold": {
        label: "Hold",
        value: "hold",
        theme: colorsObject().bdazzledBlue,
      },
      "confirmed": {
        label: "Confirmed",
        value: "confirmed",
        theme: colorsObject().bottleGreen,
      },
      "cancelled": {
        label: "Cancelled",
        value: "cancelled",
        theme: colorsObject().brickRed,
      },
      "trash": {
        label: "Trash",
        value: "trash",
        theme: colorsObject().rhythm,
      },
      "unknown": {
        label: "Unknown",
        value: "unknown",
        theme: colorsObject().darkByzantium,
      },
      11: {
        label: "Error",
        value: 11,
        theme: colorsObject().englishRed,
      },
    },
  },
}
export const loginHistory = {
  loginHistoryStatus: {
    label: "Login History Status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Success",
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
      },
      2: {
        label: "Error",
        value: 2,
        theme: colorsObject().englishRed,
      },
    },
  },
  loginHistoryDevice: {
    label: "Login History Device",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      desktop: {
        label: "Desktop",
        value: "desktop",
        theme: colorsObject().fuzzyWuzzy,
      },
      mobile: {
        label: "Mobile",
        value: "mobile",
        theme: colorsObject().bdazzledBlue,
      },
      tablet: {
        label: "tablet",
        value: "tablet",
        theme: colorsObject().blueVioletCrayola,
      },
    },
  },
};

export const ordersErrors = {
  ordersErrorsStatus: {
    label: "Orders errors status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      not_resolved: {
        label: "Not resolved",
        value: "not_resolved",
        theme: colorsObject().brickRed,
      },
      resolved: {
        label: "Resolved",
        value: "resolved",
        theme: colorsObject().paolaVeroneseGreen,
      },
    },
  },
};

export const logsQueueEmail = {
  logsQueueEmailStatus: {
    label: "Logs Queue Email Status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      0: {
        label: "Wait for process",
        value: 0,
        theme: colorsObject().burntSienna,
      },
      1: {
        label: "Done",
        value: 1,
        theme: colorsObject().bottleGreen,
      },
      2: {
        label: "Failed",
        value: 2,
        theme: colorsObject().englishRed,
      },
    },
  },
};

export const changeLog = {
  changeLogChangeGroup: {
    label: "Change log change group",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "General",
        value: 1,
        theme: colorsObject().orangeYellowCrayola,
      },
      2: {
        label: "Admin",
        value: 2,
        theme: colorsObject().amazon,
      },
      3: {
        label: "Affiliate",
        value: 3,
        theme: colorsObject().starCommandBlue,
      },
      4: {
        label: "Advertiser",
        value: 4,
        theme: colorsObject().rebeccaPurple,
      },
    },
  },
  changeLogType: {
    label: "Change log type",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Improvement",
        value: 1,
        theme: colorsObject().bottleGreen,
      },
      2: {
        label: "Bug fix",
        value: 2,
        theme: colorsObject().starCommandBlue,
      },
      3: {
        label: "New feature",
        value: 3,
        theme: colorsObject().amazon,
      },
    },
  },
};

export const postback = {
  postbackStatus: {
    label: "Postback Status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Active",
        value: 1,
        theme: colorsObject().forrestGreenCrayola,
      },

      2: {
        label: "Inactive",
        value: 2,
        theme: colorsObject().englishRed,
      },
    },
  },
  postbackType: {
    label: "Postback Type",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Lead",
        value: 1,
        theme: colorsObject().ming,
      },

      2: {
        label: "Event",
        value: 2,
        theme: colorsObject().bdazzledBlue,
      },
    },
  },
  postbackLevel: {
    label: "Postback Level",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "Global",
        value: 1,
        theme: colorsObject().starCommandBlue,
      },

      2: {
        label: "Specific",
        value: 2,
        theme: colorsObject().royalPurple,
      },
    },
  },
  postbacksEvent: {
    label: "Postbacks Event",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      3: {
        label: "Hold",
        value: 3,
        theme: colorsObject().bdazzledBlue,
      },

      4: {
        label: "Confirmed",
        value: 4,
        theme: colorsObject().bottleGreen,
      },
      5: {
        label: "Cancelled",
        value: 5,
        theme: colorsObject().brickRed,
      },

      6: {
        label: "Trash",
        value: 6,
        theme: colorsObject().rhythm,
      },
      7: {
        label: "Unknown",
        value: 7,
        theme: colorsObject().darkByzantium,
      },

      8: {
        label: "Buyout approved",
        value: 8,
        theme: colorsObject().littleBoyBlue,
      },
      9: {
        label: "Buyout hold",
        value: 9,
        theme: colorsObject().olivine,
      },

      10: {
        label: "Buyout rejected",
        value: 10,
        theme: colorsObject().paradisePink,
      },
    },
  },
  postbacksEventStandard: {
    label: "Postbacks Event Standard",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      3: {
        label: "Hold",
        value: 3,
        theme: colorsObject().bdazzledBlue,
      },

      4: {
        label: "Confirmed",
        value: 4,
        theme: colorsObject().bottleGreen,
      },
      5: {
        label: "Cancelled",
        value: 5,
        theme: colorsObject().brickRed,
      },

      6: {
        label: "Trash",
        value: 6,
        theme: colorsObject().rhythm,
      },
    },
  },
  postbacksMethod: {
    label: "Postbacks Methods",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "S2S",
        value: 1,
        theme: colorsObject().feldgrau,
      },
    },
  },
  postbacksMethodTemp: {
    label: "Postbacks Methods Temp",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "S2S",
        value: 1,
        theme: colorsObject().feldgrau,
      },
    },
  },
};

export const postbackLogs = {
  postbackLogsStatus: {
    label: "Postback Logs Status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      success: {
        label: "Success",
        value: "success",
        theme: colorsObject().forrestGreenCrayola,
      },

      error: {
        label: "Error",
        value: "error",
        theme: colorsObject().englishRed,
      },
    },
  },
};

export const httpCode = {
  httpCodeStatus: {
    label: "Htpp code status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      0: {
        label: "0 Resposne not received",
        value: 0,
        theme: colorsObject().darkByzantium,
      },
      200: {
        label: "200 OK",
        value: 200,
        theme: colorsObject().forrestGreenCrayola,
      },
      202: {
        label: "202 Accepted",
        value: 202,
        theme: colorsObject().forrestGreenCrayola,
      },
      203: {
        label: "203 Non-Authoritative Information",
        value: 203,
        theme: colorsObject().forrestGreenCrayola,
      },
      204: {
        label: "204 No Content",
        value: 204,
        theme: colorsObject().forrestGreenCrayola,
      },
      205: {
        label: "205 Reset Content",
        value: 205,
        theme: colorsObject().forrestGreenCrayola,
      },
      206: {
        label: "206 Partial Content",
        value: 206,
        theme: colorsObject().forrestGreenCrayola,
      },
      300: {
        label: "300 Multiple Choice",
        value: 300,
        theme: colorsObject().forrestGreenCrayola,
      },
      301: {
        label: "301 Moved permanently",
        value: 301,
        theme: colorsObject().sunray,
      },
      302: {
        label: "302 Found",
        value: 302,
        theme: colorsObject().sunray,
      },
      303: {
        label: "303 See Other",
        value: 303,
        theme: colorsObject().sunray,
      },
      304: {
        label: "304 Not modified",
        value: 304,
        theme: colorsObject().sunray,
      },
      307: {
        label: "307 Temporary Redirect",
        value: 305,
        theme: colorsObject().sunray,
      },
      308: {
        label: "308 Permament Redirect",
        value: 308,
        theme: colorsObject().sunray,
      },
      400: {
        label: "400 Bad Request",
        value: 400,
        theme: colorsObject().burntSienna,
      },
      401: {
        label: "401 Unathorized",
        value: 401,
        theme: colorsObject().burntSienna,
      },
      403: {
        label: "403 Forbidden",
        value: 403,
        theme: colorsObject().burntSienna,
      },
      405: {
        label: "405 Method Not Allowed",
        value: 405,
        theme: colorsObject().burntSienna,
      },
      406: {
        label: "406 Not Acceptable",
        value: 406,
        theme: colorsObject().burntSienna,
      },
      407: {
        label: "407 Proxy Authentication Required",
        value: 407,
        theme: colorsObject().burntSienna,
      },
      408: {
        label: "408 Request Timeout",
        value: 408,
        theme: colorsObject().burntSienna,
      },
      409: {
        label: "409 Conflict",
        value: 409,
        theme: colorsObject().burntSienna,
      },
      410: {
        label: "410 Gone",
        value: 410,
        theme: colorsObject().burntSienna,
      },
      411: {
        label: "411 Length Required",
        value: 411,
        theme: colorsObject().burntSienna,
      },
      412: {
        label: "412 Precondition Failed",
        value: 412,
        theme: colorsObject().burntSienna,
      },
      413: {
        label: "412 Payload Too Large",
        value: 413,
        theme: colorsObject().burntSienna,
      },
      414: {
        label: "414 Uri Too Long",
        value: 414,
        theme: colorsObject().burntSienna,
      },
      415: {
        label: "415 Unsupported Media Type",
        value: 414,
        theme: colorsObject().burntSienna,
      },
      416: {
        label: "416 Range Not Satisfiable",
        value: 416,
        theme: colorsObject().burntSienna,
      },
      417: {
        label: "417 Expectation Failed",
        value: 417,
        theme: colorsObject().burntSienna,
      },
      426: {
        label: "426 Upgrade Required",
        value: 426,
        theme: colorsObject().burntSienna,
      },
      428: {
        label: "428 Precondition Required",
        value: 428,
        theme: colorsObject().burntSienna,
      },
      429: {
        label: "429 Too Many Requests",
        value: 429,
        theme: colorsObject().burntSienna,
      },
      431: {
        label: "431 Request Header Fields Too Large",
        value: 431,
        theme: colorsObject().burntSienna,
      },
      500: {
        label: "500 Internal Server Error",
        value: 500,
        theme: colorsObject().englishRed,
      },
      501: {
        label: "501 Not Implemented",
        value: 501,
        theme: colorsObject().englishRed,
      },
      502: {
        label: "502 Bad Gateway",
        value: 502,
        theme: colorsObject().englishRed,
      },
      503: {
        label: "503 Service Unavailable",
        value: 503,
        theme: colorsObject().englishRed,
      },
      504: {
        label: "504 Gateway Timeout",
        value: 504,
        theme: colorsObject().englishRed,
      },
      505: {
        label: "505 HTTP Version Not Supported",
        value: 505,
        theme: colorsObject().englishRed,
      },
      510: {
        label: "510 Not Extended",
        value: 510,
        theme: colorsObject().englishRed,
      },
      511: {
        label: "511 Network Authentication Required",
        value: 511,
        theme: colorsObject().englishRed,
      },
    },
  },
};

export const affiliateReport = {
  statsBasedOn: {
    label: "Status based on",
    data: {
      offer: {
        label: "Offer",
        value: "offer",
        theme: colorsObject().forrestGreenCrayola,
      },
      date: {
        label: "Date",
        value: "date",
        theme: colorsObject().forrestGreenCrayola,
      },
      month: {
        label: "Month",
        value: "month",
        theme: colorsObject().forrestGreenCrayola,
      },
      day_of_week: {
        label: "Day of week",
        value: "day_of_week",
        theme: colorsObject().forrestGreenCrayola,
      },
      time: {
        label: "Time",
        value: "time",
        theme: colorsObject().forrestGreenCrayola,
      },
      hour_of_day: {
        label: "Hour of day",
        value: "hour_of_day",
        theme: colorsObject().forrestGreenCrayola,
      },
      landings: {
        label: "Landings",
        value: "landings",
        theme: colorsObject().forrestGreenCrayola,
      },
      prelandings: {
        label: "Prelandings",
        value: "prelandings",
        theme: colorsObject().forrestGreenCrayola,
      },
      country_code: {
        label: "Country",
        value: "country_code",
        theme: colorsObject().forrestGreenCrayola,
      },
      sub_1: {
        label: "Sub 1",
        value: "sub_1",
        theme: colorsObject().forrestGreenCrayola,
      },
      sub_2: {
        label: "Sub 2",
        value: "sub_2",
        theme: colorsObject().forrestGreenCrayola,
      },
      sub_3: {
        label: "Sub 3",
        value: "sub_3",
        theme: colorsObject().forrestGreenCrayola,
      },
      sub_4: {
        label: "Sub 4",
        value: "sub_4",
        theme: colorsObject().forrestGreenCrayola,
      },
      utm_campaign: {
        label: "UTM campaign",
        value: "utm_campaign",
        theme: colorsObject().forrestGreenCrayola,
      },
      utm_source: {
        label: "UTM source",
        value: "utm_source",
        theme: colorsObject().forrestGreenCrayola,
      },
      utm_medium: {
        label: "UTM medium",
        value: "utm_medium",
        theme: colorsObject().forrestGreenCrayola,
      },
      utm_term: {
        label: "UTM term",
        value: "utm_term",
        theme: colorsObject().forrestGreenCrayola,
      },
      utm_content: {
        label: "UTM content",
        value: "utm_content",
        theme: colorsObject().forrestGreenCrayola,
      },
      device_type: {
        label: "Device type",
        value: "device_type",
        theme: colorsObject().forrestGreenCrayola,
      },
      browser_name: {
        label: "Browser name",
        value: "browser_name",
        theme: colorsObject().forrestGreenCrayola,
      },
      browser_version: {
        label: "Browser version",
        value: "browser_version",
        theme: colorsObject().forrestGreenCrayola,
      },
      os_name: {
        label: "OS name",
        value: "os_name",
        theme: colorsObject().forrestGreenCrayola,
      },
      os_version: {
        label: "OS version",
        value: "os_version",
        theme: colorsObject().forrestGreenCrayola,
      },
    },
  },
};

export const news = {
  newsStatus: {
    label: "Status",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      unpublished: {
        label: "Unpublished",
        value: "unpublished",
        theme: colorsObject().englishRed,
      },
      published: {
        label: "Published",
        value: "published",
        theme: colorsObject().forrestGreenCrayola,
      },
      draft: {
        label: "Draft",
        value: "draft",
        theme: colorsObject().bdazzledBlue,
      },
    },
  },
  newsCategory: {
    label: "Category",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      1: {
        label: "General",
        value: 1,
        theme: colorsObject().starCommandBlue,
      },
      2: {
        label: "Payouts",
        value: 2,
        theme: colorsObject().skobeloff,
      },
      3: {
        label: "New offers",
        value: 3,
        theme: colorsObject().jazzberryJam,
      },
      4: {
        label: "New geos",
        value: 4,
        theme: colorsObject().flickrPink,
      },
      5: {
        label: "Offers STOP",
        value: 5,
        theme: colorsObject().maximumBlueGreen,
      },
      6: {
        label: "Offers Renew",
        value: 6,
        theme: colorsObject().fandago,
      },
      7: {
        label: "Special offer",
        value: 7,
        theme: colorsObject().bitterSweet,
      },
    },
  },
  newsAutomaticDeletionAfter: {
    label: "Automatic Deletion after",
    data: {
      default: {
        label: "N/A",
        value: null,
        theme: colorsObject().cadetGrey,
      },
      'never': {
        label: "Never",
        value: 'never',
        theme: colorsObject().starCommandBlue,
      },
      86400: {
        label: "1 Day",
        value: 86400,
        theme: colorsObject().skobeloff,
      },
      604800: {
        label: "7 Days",
        value: 604800,
        theme: colorsObject().jazzberryJam,
      },
      1209600: {
        label: "14 Days",
        value: 1209600,
        theme: colorsObject().flickrPink,
      },
      2592000: {
        label: "30 Days",
        value: 2592000,
        theme: colorsObject().maximumBlueGreen,
      }
    }
  },
};
